import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Tc() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Transfer"
          title2="Certificate"
          parentTitle="Academic"
          path="Transfer Certificate"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody py-5">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-xl-10">
              <div className="contact-form-card manage">
                <h2 className="about-title">Transfer Certificate</h2>

                <div className="row align-items-start gx-2">
                  {/* Form */}
                  <div className="col-xl-5 col-md-12">
                    <form id="tc-form">
                      <div className="form-group">
                        <label htmlFor="number">Admission No.</label>
                        <input
                          name="admission"
                          type="text"
                          className="form-control"
                        />
                      </div>

                      <div className="mt-3">
                        <div className="form-group">
                          <label htmlFor="name">Student Name</label>
                          <input
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="mt-3">
                        <input
                          type="submit"
                          name="btnshwtcdetails"
                          className="viewdetailsbtn"
                          value="View Details"
                        />
                      </div>

                      <div id="result"></div>
                    </form>
                  </div>

                  {/* PDF */}
                  <div className="col-xl-7 col-md-12">
                    <iframe
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/pdf/TC-sample.pdf#toolbar=0"
                      className="w-100 border-0"
                      height="500"
                      title="Transfer Certificate Sample"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Tc;
